import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Grid,
  Typography, 
  Box
} from "@mui/material";

import Radio from "@/components/ph/Radio";

import FormSection from "../../utils/FormSection";

import { setFormValue, setValidValue } from "../../contractor/contractorSlice";

const ContractorRadioField = () => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.contractor.formValues);
  const validValues = useSelector((state) => state.contractor.validValues);
  
  const handleChange = (value) => {
    
    dispatch(setFormValue({ field: "esMismoDomicilioFiscal", value }));
    
    if (value === "Si") {
      const fieldsToCopy = [
        "codigoPostal",
        "colonia",
        "alcaldiaMunicipio",
        "estadoRepublica",
        "calle",
        "numeroExterior",
        "numeroInterior",
      ];

      fieldsToCopy.forEach((f) => {
        const fiscalField = "fiscal" + f.charAt(0).toUpperCase() + f.slice(1);
        const fieldValue = formValues[f] ?? "";
        const fieldValid = validValues[f];
        dispatch(setFormValue({ field: fiscalField, value: fieldValue }));
        dispatch(setValidValue({ field: fiscalField, isValid: fieldValid }));
      });
      
    } else {
      const fieldsToReset = [
        "fiscalCodigoPostal",
        "fiscalColonia",
        "fiscalAlcaldiaMunicipio",
        "fiscalEstadoRepublica",
        "fiscalCalle",
        "fiscalNumeroExterior",
        "fiscalNumeroInterior",
      ];
      fieldsToReset.forEach((f) => {
        dispatch(setFormValue({ field: f, value: "" }));
        dispatch(setValidValue({ field: f, isValid: false }));
      });
    }
  };

  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <FormSection >
        <Grid container spacing={2}>
            <Grid size={{ xs: 12}}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box
                    sx={{
                        minHeight: "3.5rem",
                        display: "flex",
                        alignItems: "flex-end",
                    }}
                    >
                    <Typography
                        variant="body1"
                        sx={{
                        color: "text.secondary",
                        mt: 1,
                        fontSize: "1rem",
                        }}
                    >
                        ¿El Domicilio fiscal es igual al domicilio particular?
                    </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box
                    sx={{
                        minHeight: "3.5rem",
                        display: "flex",
                        alignItems: "flex-end",
                    }}
                    >
                    <Radio
                        name="esMismoDomicilioFiscal"
                        value="Si"
                        label="Si"
                        checked={formValues.esMismoDomicilioFiscal === "Si"}
                        onChange={handleChange}
                    />
                    <Radio
                        value="No"
                        label="No"
                        name="esMismoDomicilioFiscal"
                        checked={formValues.esMismoDomicilioFiscal === "No"}
                        onChange={handleChange}
                    />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default ContractorRadioField;